package learning.containers


import com.jingfangpai.api.clients.ContentApiClient
import com.jingfangpai.common.orm.mapping.enums.ContentType
import react.*
import react.dom.div
import setTitle
import learning.components.MeridianEdit

external interface MeridianEditPageProps : RProps {
    var id:String
}

data class MeridianEditPageContextData(
    var saveContent:(content:com.jingfangpai.common.orm.mapping.Content, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.content.model.ContentVo>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var getContent:(type: ContentType, id:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.content.model.ContentVo>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
)

val MeridianEditPageContext = createContext(MeridianEditPageContextData(ContentApiClient::saveContent,ContentApiClient::getContent))

val MeridianEditPageProvider = functionalComponent<MeridianEditPageProps> { props ->

    setTitle("经络编辑")

    fun placeHolderFunction(param: String) {
        console.log("doing something with param")
    }

    useEffectOnce { }

    MeridianEditPageContext.Provider(MeridianEditPageContextData(ContentApiClient::saveContent,ContentApiClient::getContent)) {
        div("MeridianEditPage-content") {
            child(MeridianEdit) {
                attrs{
                    id = props.id
                }
            }
        }
    }
}
